import * as Yup from 'yup'

export const initialValues = {
  active: true,
  content: '',
  marketSegmentId: '',
  scheduledCommunicationTypeId: '',
}

export const formSchema = Yup.object().shape({
  active: Yup.bool().required('Active is required.'),
  content: Yup.string().required('Each Scheduled Communication Template requires content.'),
  marketSegmentId: Yup.number().required('A Market Segement is required.'),
  scheduledCommunicationTypeId: Yup.number().required('A Scheduled Communication Type is required.'),
})

export interface FormValuesType {
  active: boolean
  content: string
  marketSegmentId?: string
  scheduledCommunicationTypeId?: string
}
